import GenericService from './genericService';
import axiosInstance from '../utils/axios';

class CashMemoService extends GenericService {
  constructor() {
    super('/cash_memos', axiosInstance);
  }
}

export default new CashMemoService(); 